var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideStaffBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 20.125V18.2083C5.75 17.1917 6.15387 16.2166 6.87276 15.4978C7.59165 14.7789 8.56667 14.375 9.58333 14.375H11.9792M18.2093 20.125C17.701 20.125 17.2135 19.9231 16.854 19.5636C16.4946 19.2042 16.2926 18.7167 16.2926 18.2083C16.2926 17.7 16.4946 17.2125 16.854 16.853C17.2135 16.4936 17.701 16.2917 18.2093 16.2917M18.2093 20.125C18.7176 20.125 19.2051 19.9231 19.5646 19.5636C19.924 19.2042 20.126 18.7167 20.126 18.2083C20.126 17.7 19.924 17.2125 19.5646 16.853C19.2051 16.4936 18.7176 16.2917 18.2093 16.2917M18.2093 20.125V21.5625M18.2093 16.2917V14.8542M21.114 16.5312L19.8691 17.25M16.5504 19.1667L15.3046 19.8854M15.3046 16.5312L16.5504 17.25M19.8691 19.1667L21.115 19.8854M7.66667 6.70833C7.66667 7.725 8.07053 8.70002 8.78942 9.41891C9.50831 10.1378 10.4833 10.5417 11.5 10.5417C12.5167 10.5417 13.4917 10.1378 14.2106 9.41891C14.9295 8.70002 15.3333 7.725 15.3333 6.70833C15.3333 5.69167 14.9295 4.71665 14.2106 3.99776C13.4917 3.27887 12.5167 2.875 11.5 2.875C10.4833 2.875 9.50831 3.27887 8.78942 3.99776C8.07053 4.71665 7.66667 5.69167 7.66667 6.70833Z",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideStaffBlack);
export default __webpack_public_path__ + "static/media/sideStaffBlack.a1e7c55c613f951e395122e5d3358004.svg";
export { ForwardRef as ReactComponent };